import endpoints from '@/services/http/endpoints'
import http from '@/services/http/index'

export default {
  /**
   * Get next edition document by type for the child.
   * @param {Object} payload - The payload for the getByType request.
   * @param {boolean} [isCoordinator='false'] - Boolean if should send request on coordinator endpoint.
   * @returns {Promise} - A promise that resolves with the response data.
   */
  getByType(payload, isCoordinator = false) {
    const endpoint = isCoordinator ? 'documentForCoordinator' : 'document'
    return http.get(endpoints.get(endpoint, { ...payload }))
  },
  /**
   * Sace a child next edition document.
   * @param {Object} payload - The payload for the post request.
   * @param {boolean} [isCoordinator='false'] - Boolean if should send request on coordinator endpoint.
   * @returns {Promise} - A promise that resolves with the response data.
   */
  post(payload, isCoordinator = false) {
    const endpoint = isCoordinator ? 'documentForCoordinator' : 'document'
    return http.post(endpoints.get(endpoint, { ...payload }), payload.data)
  },
  /**
   * Checks the application status for the next edition using a provided hash
   * @param {string} hash - The unique hash identifier for the application
   * @returns {Promise} Promise object representing the HTTP GET request response
   */
  nextEditionApplicationCheck(hash) {
    return http.get(endpoints.get('nextEditionAplicationCheck', { hash }))
  },
  /**
   * Submits an application for the next edition using the provided hash and payload.
   *
   * @param {string} hash - The unique identifier for the application.
   * @param {Object} payload - The data to be sent in the request body.
   * @returns {Promise<Object>} A promise that resolves with the API response.
   */
  nextEditionApplication(hash, payload) {
    return http.post(endpoints.get('nextEditionApplication', { hash }), payload)
  }
}
